export { default as pulseSpin } from './pulseSpin.vue';
export { default as rectSpin } from './rectSpin.vue';
export { default as planeSpin } from './planeSpin.vue';
export { default as cubeSpin } from './cubeSpin.vue';
export { default as preloaderSpin } from './preloaderSpin.vue';
export { default as chaseSpin } from './chaseSpin.vue';